(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mssd-cart-summary"] && !Shopify.designMode) return;
  try {
    
(() => {
  const validHouses = ["Mom's House", "Dad's House"];
  const selector = '.mssd-cart-summary select[name="attributes[Order House]"]';
  let confirmedHouse = '', saving = false, revision = 0;
  const root = window.Shopify?.routes?.root || '/';
  const select = () => document.querySelector(selector);
  const render = (message = '') => {
    const el = select(), summary = document.querySelector('.mssd-cart-summary');
    if (!el || !summary) return;
    const ready = !saving && validHouses.includes(confirmedHouse) && el.value === confirmedHouse;
    summary.dataset.houseReady = ready ? confirmedHouse : '';
    const shipping = summary.querySelector('[data-mssd-shipping]');
    if (shipping && shipping.dataset.busy !== 'true') { shipping.disabled = !ready; shipping.setAttribute('aria-disabled', String(!ready)); }
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(b => { b.disabled = !ready; b.setAttribute('aria-disabled', String(!ready)); });
    const details = summary.querySelector('[data-mssd-house-details]');
    if (details) details.open = true;
    summary.querySelector('[data-mssd-house-summary-label]').textContent = 'Choose a delivery group';
    summary.querySelector('[data-mssd-house-summary-value]').textContent = ready ? confirmedHouse : 'Required';
    const status = summary.querySelector('[data-mssd-house-status]');
    status.dataset.state = ready ? 'ready' : saving ? 'saving' : 'required';
    status.textContent = message || (ready ? 'Delivery group saved for this order.' : saving ? 'Saving delivery group…' : 'Select Mom’s House or Dad’s House to continue.');
  };
  const write = async house => {
    const response = await fetch(root + 'cart/update.js', {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({attributes:{'Order House':house,'Fundraiser':document.querySelector('.mssd-cart-summary')?.dataset.campaign || '',Seller:'Mia Gallant','Delivery Method':'Family Delivery'}})});
    if (!response.ok) throw new Error('Could not save house');
    const cart = await response.json();
    if (house && cart.attributes?.['Order House'] !== house) throw new Error('House was not saved');
  };
  // Serialize writes so a reset cannot overwrite a later deliberate choice.
  let writes = Promise.resolve();
  const queueWrite = house => (writes = writes.catch(() => {}).then(() => write(house)));
  const reset = () => {
    confirmedHouse = ''; saving = true; revision++;
    if (select()) select().value = '';
    render('Choose a delivery group for this order.');
    const current = revision;
    queueWrite('').then(() => {if (current !== revision) return; saving = false; render();}).catch(() => {if (current !== revision) return; saving = false; render('Select a delivery group to save it before checkout.');});
  };
  document.addEventListener('change', async event => {
    if (!event.target.matches(selector)) return;
    const house = event.target.value, current = ++revision;
    confirmedHouse = ''; saving = true; render();
    try {
      await queueWrite(validHouses.includes(house) ? house : '');
      if (current !== revision) return;
      confirmedHouse = validHouses.includes(house) ? house : ''; saving = false; render();
    } catch {
      if (current !== revision) return;
      saving = false; render('Could not save your house. Choose it again to retry.');
    }
  });
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout') return;
    if (!saving && validHouses.includes(confirmedHouse) && select()?.value === confirmedHouse) return;
    event.preventDefault(); render(); select()?.focus();
  }, true);
  let observed = select();
  new MutationObserver(() => {
    const el = select(); if (!el || el === observed) return;
    observed = el; el.value = confirmedHouse; render();
  }).observe(document.documentElement, {childList:true,subtree:true});
  const start = () => {observed = select(); if (observed) reset();};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  window.addEventListener('pageshow', event => {if (event.persisted) reset();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mssd-checkout-guard"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const guard = document.querySelector('.mssd-checkout-guard');
    const salePath = guard?.dataset.salePath || '/collections/sheets-for-mia';
    const continueLabel = guard?.dataset.continueLabel || 'Continue shopping';
    const saleClosed = guard?.dataset.saleClosed === 'true';
    const updateCartLinks = () => {
      document.querySelectorAll('.cart__warnings a.button, .title-wrapper-with-link a.underlined-link').forEach((link) => {
        link.href = salePath;
        link.textContent = continueLabel;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateCartLinks, { once: true });
    } else {
      updateCartLinks();
    }

    if (saleClosed) {
      document.querySelectorAll('form[action*="/cart/add"], form[action="/cart"]').forEach((form) => {
        form.addEventListener('submit', (event) => event.preventDefault(), true);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mssd-order-house"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeHouseSelectors = () => {
      const validHouses = ["Mom's House", "Dad's House"];

      document.querySelectorAll('[data-mssd-cart-house]').forEach((section) => {
        if (section.dataset.initialized === 'true') return;
        section.dataset.initialized = 'true';

        const select = section.querySelector('select[name="attributes[Order House]"]');
        const status = section.querySelector('[data-mssd-house-status]');
        if (!select) return;

        const checkoutButtons = () => Array.from(document.querySelectorAll('button[name="checkout"], input[name="checkout"]'))
          .filter((button) => button.form && button.form.id === 'cart');
        const hasValidHouse = () => validHouses.includes(select.value);
        const setCheckoutState = () => {
          const valid = hasValidHouse();
          checkoutButtons().forEach((button) => {
            button.disabled = !valid;
            button.setAttribute('aria-disabled', String(!valid));
          });
          if (!valid && status) {
            status.dataset.state = 'error';
            status.textContent = 'Select a house to continue to checkout.';
          }
          return valid;
        };

        select.addEventListener('change', () => {
          const valid = setCheckoutState();
          if (valid && status) {
            status.dataset.state = 'saved';
            status.textContent = 'Ready for checkout.';
          }
        });

        document.addEventListener('submit', (event) => {
          const submitter = event.submitter;
          if (submitter && submitter.name === 'checkout' && !setCheckoutState()) {
            event.preventDefault();
            section.scrollIntoView({ behavior: 'smooth', block: 'center' });
            select.focus();
          }
        }, true);

        setCheckoutState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeHouseSelectors);
    } else {
      initializeHouseSelectors();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mssd-product-dock"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const docks = Array.from(document.querySelectorAll('[data-mssd-product-dock]'));
    if (!docks.length) return;

    const getMainForm = () => Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find((form) => !form.closest('[data-mssd-product-dock]'));
    let syncTimer;

    const syncDock = (variantId, syncQuantity = true) => {
      const mainForm = getMainForm();
      if (!mainForm) return;
      const mainVariant = mainForm.querySelector('input[name="id"]');
      const mainQuantity = document.querySelector('.product__info-container input[name="quantity"]');
      const mainButton = mainForm.querySelector('[name="add"]');
      const currentVariantId = String(variantId || mainVariant?.value || '');

      docks.forEach((dock) => {
        const dockVariant = dock.querySelector('[data-mssd-dock-variant]');
        const dockQuantity = dock.querySelector('[data-mssd-dock-quantity]');
        const dockOption = dock.querySelector('[data-mssd-dock-option]');
        const dockPrice = dock.querySelector('[data-mssd-dock-price]');
        const dockButton = dock.querySelector('[data-mssd-dock-button]');
        const variantData = Array.from(dock.querySelectorAll('[data-variant-id]')).find((item) => item.dataset.variantId === currentVariantId);

        if (currentVariantId && dockVariant) dockVariant.value = currentVariantId;
        if (syncQuantity && mainQuantity && dockQuantity && document.activeElement !== dockQuantity) {
          dockQuantity.value = Math.max(1, Number.parseInt(mainQuantity.value, 10) || 1);
        }
        if (variantData && dockOption) dockOption.textContent = variantData.dataset.variantOption;
        if (variantData && dockPrice) dockPrice.textContent = variantData.dataset.variantPrice;

        if (dockButton) {
          const isAvailable = variantData ? variantData.dataset.variantAvailable === 'true' : !mainButton?.disabled;
          dockButton.disabled = !isAvailable;
          dockButton.textContent = isAvailable ? 'Add to cart' : 'Unavailable';
        }
      });
    };

    const queueSync = (variantId) => {
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(() => syncDock(variantId), 100);
    };

    document.addEventListener('change', (event) => {
      const dock = event.target.closest('[data-mssd-product-dock]');
      if (dock) {
        if (event.target.matches('[data-mssd-dock-quantity]')) {
          event.target.value = Math.max(1, Number.parseInt(event.target.value, 10) || 1);
        }
        return;
      }

      if (event.target.matches('form[action*="/cart/add"] input[name="id"]')) {
        syncDock(event.target.value);
        return;
      }

      const isOption = event.target.closest('variant-selects, variant-radios, .product-form__input');
      const isQuantity = event.target.matches('input[name="quantity"]');
      if (!isOption && !isQuantity) return;
      queueSync();
    });

    document.addEventListener('click', (event) => {
      const quantityButton = event.target.closest('[data-mssd-dock-quantity-change]');
      if (!quantityButton) return;
      const dock = quantityButton.closest('[data-mssd-product-dock]');
      const quantityInput = dock?.querySelector('[data-mssd-dock-quantity]');
      if (!quantityInput) return;
      const change = Number.parseInt(quantityButton.dataset.mssdDockQuantityChange, 10) || 0;
      quantityInput.value = Math.max(1, (Number.parseInt(quantityInput.value, 10) || 1) + change);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    docks.forEach((dock) => {
      dock.querySelector('form')?.addEventListener('submit', () => syncDock(null, false));
    });

    const productInfo = document.querySelector('.product__info-container');
    if (productInfo) {
      new MutationObserver(() => queueSync()).observe(productInfo, { childList: true, subtree: true });
    }

    syncDock();
  })();

  } catch(e) { console.error(e); }
})();
})();
